export const GET_DEVICE_LIST = "GET_DEVICE_LIST";
export const GET_CURRENT_ORG = "GET_CURRENT_ORG";
